module.exports = __webpack_public_path__ + "media/wrong.f08aea4e.mp3";